module.exports = __webpack_public_path__ + "img/sami.120010a8.png";